// extracted by mini-css-extract-plugin
module.exports = {"layout-container":"LayoutWrapper_layout-container__kKd_B","loading":"LayoutWrapper_loading__GvgnP","content-wrapper":"LayoutWrapper_content-wrapper__6CiMw"};